import {customElement} from "lit/decorators.js";
import {DialogAnchorTemplateContent} from "./dialogAnchorTemplateContent";


@customElement("eop-download-dialog")
export class EopDownloadDialog extends DialogAnchorTemplateContent {

    public connectedCallback(): void {
        super.connectedCallback();

        if (!this.dialogContent) {
            return;
        }

        this.dialogContent.classList.add("download-dialog");
        if (this.dialogContent.classList.contains("lightbox-dialog")) {
            this.openDialogOnPreviewImageInteraction();
        } else if (this.dialogContent.classList.contains("disclaimer-dialog")) {
            this.openDialogOnPreviewImageInteraction();
            this.querySelector(".download-label")!.addEventListener("click", event => this.openDialogFromInteraction(event));
        }
    }

    private openDialogOnPreviewImageInteraction(): void {
        const previewImageElement = this.querySelector(".download-preview-image");
        if (previewImageElement !== null) {
            previewImageElement.addEventListener("click", event => this.openDialogFromInteraction(event));
        }
    }

    private openDialogFromInteraction(event: Event): void {
        event.preventDefault();
        this.openDialog(event);
    }
}
